import * as banners from "./page0Images"
import * as animations from "../../../animations"
import EnergyFlagComponent from './EnergyFlagComponent.jsx';
import PeopleComponent from "./PeopleComponent.jsx";
import GriLottie from "../../dsy-inhouse/GriLottiePlayer.jsx";

const page0styles = {
    monofamiliare: {
        __self__: {
            img: banners.monofamiliare,
            style: {
                left: "0",
                top: "0",
            }
        },
        ringhiera:{
            img: banners.ringhiera,
            style: {
                bottom: "46%",
                left: "40%",
                width: "18%"
            }
        },
        muratura:{
            img: banners.muratura,
            style: {
                bottom: "46%",
                left: "40%",
                width: "18%"
            }
        },
        focusBalcone: {
            img: animations.focusS,
            style: {
                zIndex: "5",
                width: "30%",
                bottom: "42%",
                left: "35%",
            }
        },
        fotovoltaico: {
            img: banners.fotovoltaico,
            style: {
                top: "7%",
                left: "12%",
                width: "17%"
            }
        },
        ristrutturato: {
            img: banners.ristrutturato,
            style: {
                top: "15%",
                left: "-5%",
                width: "10%"
            }
        },
        coibentato: {
            img: banners.coibentato,
            style: {
                top: "5%",
                left: "41%",
                width: "10%",
                transform: "rotate(5deg)"
            }
        },
        flag: {
            img: null,
            style: {
                top: "0%",
                right: "24%",
                width: "18%"
            }
        },
        airco: {
            img: banners.airco,
            style: {
                bottom: "23%",
                left: "12%",
                width: "14%"
            }
        },
        acHeat: {
            img: banners.acHeat,
            style: {
                bottom: "23%",
                left: "12%",
                width: "14%"
            }
        },
        people: {
            img: banners.people.right,
            style: {
                bottom: "9%",
                right: "30%",
                width: "30%"
            }
        }
    },
    bifamiliare: {
        __self__: {
            img: banners.bifamiliare,
            style: {
                left: "0",
                top: "0",
            }
        },
        focusBalcone: {
            img: animations.focusS,
            style: {
                zIndex: "5",
                width: "25%",
                top: "13%",
                right: "20%",
                position: "absolute"
            }
        },
        ringhiera:{
            img: banners.ringhiera,
            style: {
                top: "23%",
                left: "59%",
                width: "17%"
            }
        },
        muratura:{
            img: banners.muratura,
            style: {
                top: "23%",
                left: "59%",
                width: "17%"
            }
        },
        fotovoltaico: {
            img: banners.fotovoltaico,
            style: {
                top: "0%",
                left: "24%",
                width: "14%"
            }
        },
        ristrutturato: {
            img: banners.ristrutturato,
            style: {
                top: "5%",
                left: "15%",
                width: "8%"
            }
        },
        coibentato: {
            img: banners.coibentato,
            style: {
                top: "8%",
                left: "53%",
                width: "8%",
                transform: "rotate(5deg)"
            }
        },
        flag: {
            img: null,
            style: {
                top: "30%",
                right: "11%",
                width: "15%"
            }
        },
        airco : {
            img: banners.aircoMirror,
            style: {
                bottom: "30%",
                right: "12%",
                width: "10%"
            }
        },
        acHeat : {
            img: banners.acHeatMirror,
            style: {
                bottom: "30%",
                right: "12%",
                width: "10%"
            }
        },
        people: {
            img: banners.people.left,
            style: {
                bottom: "10%",
                right: "38%",
                width: "30%"
            }
        }
    },
    piccolo: {
        __self__: {
            img: banners.piccolo,
            style: {
                left: "0",
                top: "0",
            }
        },
        focusBalcone: {
            img: animations.focusS,
            style: {
                zIndex: "5",
                width: "30%",
                bottom: "38%",
                left: "50%",
            }
        },
        ringhiera:{
            img: banners.ringhiera,
            style: {
                bottom: "38%",
                left: "60%",
                width: "16%"
            }
        },
        muratura:{
            img: banners.muratura,
            style: {
                bottom: "34%",
                left: "59%",
                width: "16%"
            }
        },
        fotovoltaico: {
            img: banners.fotovoltaico,
            style: {
                top: "20%",
                left: "30%",
                width: "14%"
            }
        },
        ristrutturato: {
            img: banners.ristrutturato,
            style: {
                top: "14%",
                left: "9%",
                width: "9%"
            }
        },
        coibentato: {
            img: banners.coibentato,
            style: {
                top: "8%",
                right: "45%",
                width: "10%",
                transform: "rotate(5deg)"
            }
        },
        flag: {
            img: null,
            style: {
                top: "20%",
                right: "25%",
                width: "18%"
            }
        },
        airco : {
            img: banners.aircoMirror,
            style: {
                bottom: "23%",
                left: "62%",
                width: "12%"
            }
        },
        acHeat : {
            img: banners.acHeatMirror,
            style: {
                bottom: "23%",
                left: "62%",
                width: "12%"
            }
        },
        people: {
            img: banners.people.group,
            style: {
                bottom: "14%",
                right: "52%",
                width: "36%"
            }
        }
    },
    medio: {
        __self__: {
            img: banners.medio,
            style: {
                left: "0",
                top: "0",
            }
        },
        focusBalcone: {
            img: animations.focusS,
            style: {
                zIndex: "5",
                width: "25%",
                bottom: "55%",
                right: "19%",
                position: "absolute"
            }
        },
        ringhiera:{
            img: banners.ringhiera,
            style: {
                top: "32%",
                left: "60%",
                width: "18%"
            }
        },
        muratura:{
            img: banners.muratura,
            style: {
                top: "32%",
                left: "60%",
                width: "18%"
            }
        },
        fotovoltaico: {
            img: banners.fotovoltaico,
            style: {
                top: "0%",
                left: "19%",
                width: "14%"
            }
        },
        ristrutturato: {
            img: banners.ristrutturato,
            style: {
                top: "5%",
                left: "6%",
                width: "10%"
            }
        },
        coibentato: {
            img: banners.coibentato,
            style: {
                top: "6%",
                left: "58%",
                width: "10%",
                transform: "rotate(5deg)"
            }
        },
        flag: {
            img: null,
            style: {
                top: "12%",
                right: "18%",
                width: "16%"
            }
        },
        airco : {
            img: banners.aircoMirror,
            style: {
                bottom: "16%",
                left: "62%",
                width: "14%"
            }
        },
        acHeat : {
            img: banners.acHeatMirror,
            style: {
                bottom: "16%",
                left: "62%",
                width: "14%"
            }
        },
        people: {
            img: banners.people.group,
            style: {
                bottom: "13%",
                right: "52%",
                width: "32%"
            }
        }
    },     
    grande: {
        __self__: {
            img: banners.grande,
            style: {
                left: "0",
                top: "0",
            }
        },
        focusBalcone: {
            img: animations.focusS,
            style: {
                zIndex: "5",
                width: "25%",
                top: "18%",
                right: "24%",
                position: "absolute"
            }
        },
        ringhiera:{
            img: banners.ringhiera,
            style: {
                top: "23%",
                left: "55%",
                width: "15%"
            }
        },
        muratura:{
            img: banners.muratura,
            style: {
                top: "23%",
                left: "55%",
                width: "15%"
            }
        },
        fotovoltaico: {
            img: banners.fotovoltaico,
            style: {
                top: "2%",
                left: "30%",
                width: "14%"
            }
        },
        ristrutturato: {
            img: banners.ristrutturato,
            style: {
                top: "5%",
                left: "16%",
                width: "10%"
            }
        },
        coibentato: {
            img: banners.coibentato,
            style: {
                top: "0%",
                left: "45%",
                width: "10%",
                transform: "rotate(5deg)"
            }
        },
        flag: {
            img: null,
            style: {
                top: "3%",
                right: "22%",
                width: "15%"
            }
        },
        airco : {
            img: banners.aircoMirror,
            style: {
                bottom: "19%",
                left: "58%",
                width: "11%"
            }
        },
        acHeat : {
            img: banners.acHeatMirror,
            style: {
                bottom: "19%",
                left: "58%",
                width: "11%"
            }
        },
        people: {
            img: banners.people.group,
            style: {
                bottom: "12%",
                right: "50%",
                width: "32%"
            }
        }
    }
};

export default function handlePage0(data) {
    
    const initial = banners.italy;

    const result = []

    const tipologia = data["C11"]?.split(" ")[0]?.split("/")[0]?.toLowerCase()

    // focus su indirizzo casa
    if (data["focus"] === "indirizzo") {
        //const condo = page0styles[tipologia].__self__
        //result.push(<GriLottie animationData={zollaAnimation} />)      //  style={{ width: 300, height: 300 }}
        //result.push(<img style={condo.style} src={condo.img} alt="" role="presentation" />)+
        return[<GriLottie animationData={animations.zollaPin} style={{"position": "absolute", "bottom": "0%"}}/>]
    }
    // base image wiht italy map, comes out where no images is present
    if (result.length === 0 && !tipologia && data["focus"] !== "C11" && !data["C14"]) {
         return [<img src={initial} style={{"top": "20%"}} alt="" role="presentation"/>]
    }
    // indirizzo
    if (data["C14"] && !data["C11"]) {
        result.push(<img src={banners.zollaPin} alt="" role="presentation" />)
    }

    // condominio + zolla
    if (data["C11"]){
        //const zolla = page0styles[tipologia].zolla
        const condo = page0styles[tipologia].__self__
        //result.push(<img style={zolla.style} src={zolla.img} alt="" role="presentation" />)
        result.push(<img style={condo.style} src={condo.img} alt="" role="presentation" />)
    }
    if (data["focus"] === "TipologiaBalconi" && tipologia) {
        const animation = page0styles[tipologia].focusBalcone;
        result.push(<GriLottie animationData={animation.img} style={animation.style}/>)
    }
    // balconi
    if (!!data["TipologiaBalconi"] && page0styles[tipologia] && data["PresenzaBalcone"] === true){
        const balconyType = data["TipologiaBalconi"].toLowerCase()
        const balcony = page0styles[tipologia][balconyType]
        if (data["focus"] !== "TipologiaBalconi") {
            result.push(<img style={balcony.style} src={balcony.img} role="presentation" alt="" />)
        }
    }
    // antenna fotovoltaico
    if (!!data["PresenzaFotovoltaico"] && page0styles[tipologia]) {
        const fotovoltaico = page0styles[tipologia].fotovoltaico
        result.push(<img style={fotovoltaico.style} src={fotovoltaico.img} role="presentation" alt="" />)
    }
    // stelline ristrutturato
    if (!!data["RistrutturatoUltimi10Anni"] && page0styles[tipologia]) {
        const ristrutturato = page0styles[tipologia].ristrutturato
        result.push(<img style={ristrutturato.style} src={ristrutturato.img} role="presentation" alt="" />)
    }
    // cuffietta coibentato
    if (!!data["Coibentato"] && page0styles[tipologia]){
        const coibentato = page0styles[tipologia].coibentato
        result.push(<img style={coibentato.style} src={coibentato.img} role="presentation" alt="" />)
    }
    // bandierina classe energetica
    if (!!data["C36"] && page0styles[tipologia] ) {
        const flag = page0styles[tipologia]?.flag
        result.push(<EnergyFlagComponent style={flag.style} energyClass={data["C36"]}/>)
    }
    // box aria condizionata + pompa di calore
    if (!!data["C19"]) {
        const key = !!data["CondizionatoriRiscaldamento"] ? "acHeat" : "airco";
        // console.log(tipologia, key, page0styles[tipologia][key])
        const air = page0styles[tipologia][key];
        result.push(<img style={air.style} src={air.img} role="presentation" alt="" />)
    }
    //people
    if (!!data["C15"] && data["C15"] > 0 && tipologia && data["screen"] !== 1) {
        const people = page0styles[tipologia].people
        result.push(<PeopleComponent style={people.style} amount={data["C15"]} images={people.img}/>)
    }
    
    return result
}